import React, { useState, useEffect, useRef } from 'react';
import styles from '../styles/Share.module.css';
import { useHistory } from 'react-router';
import * as firebase from 'firebase/app';
import { loginUser, logoutUser } from '../firebaseConfig';
import Spinner from '../Spinner/Spinner';

import Recepti from '../pages/ApplicationContent/Recepti';
import WeightGraph from '../pages/ApplicationContent/WeightGraph';
import GlucozeGraph from '../pages/ApplicationContent/Glucoze';
import PreasureGraph from '../pages/ApplicationContent/Bloodpreasure';
import RestInfo from '../pages/ApplicationContent/Restinfo';

// import PropTypes from 'prop-types';
// const propTypes = {
//     location: PropTypes.object.isRequired,
//};

function Share(props) {

    const [queryParam, setQueryParam] = useState(''); // getting PARAM from URL
    const [userId, setUserId] = useState(); // getting userID
    const [selectedUser, setSelectedUser] = useState(); // getting USER from ID
    const [lastWeight, setLastWeight] = useState(); // getting last weight
    const [selectedUserName, setSelectedUserName] = useState(""); // getting username

    const [showSpinner, setShowSpinner] = useState(true);
    
    const history = useHistory();

    // *
    // best way to check for mounted component !!
    const isCurrent = useRef(true);
    useEffect(() => {
        return () => {
        isCurrent.current = false;
        }
    }, [])
    // * for checking mounted components
    // *
    // then use 
    // if (isCurrent.current) { setState(XXYY) }  !!

    // const queryPresent = location.search !== '';
    // function queryStringTitle() {
    //     if (queryPresent) return 'The query string field-value pairs are:';
    //     return 'No query string in the url';
    // }

    const gettingQueryParams = () => {
        // getting url param for ?query=
        const query = new URLSearchParams(props.location.search)
        const getQuery = query.get('share');
        
        if (getQuery === undefined || getQuery.length !== 30 ) {
            //easy fix later set page !!
            history.push('/' + getQuery)
            console.log('query is undefined or less or greater then 30 chars - changed to !=');
        } else {
            console.log("getQuery: " + getQuery)
            if (isCurrent.current) { setQueryParam(getQuery) }
        }
    }

    //   getting DATA from firebase  //

    const getDataFirebase = (qParam) => {
        //let array: any;
        let data;
        console.log("checking how many times it renders !!")
        // getting data from location for WEIGHT
        let getData = firebase.database().ref('/users/');
        getData.on('value', function(snapshot) {
            console.log(snapshot.val());
            data = snapshot.val();
            if (data !== null) {
                // getting data to correct form ID: [key], NAME:
                const allUsersData = Object.keys(data).map( key => {
                return  { id: key, name: data[key].username, share: data[key].share };
                })
                //console.log(allUsersData)
                // getting only user that maches query PARAM
                //test
                //const queryParam = "w{Ed@Bl4(W";
                const eachWithShare = allUsersData.filter(each => each.share !== undefined)
                const each = eachWithShare.filter(each => each.share.share === qParam)
                if (isCurrent.current) { setSelectedUser(each) }
                console.log(each)
                console.log("qParam: " + qParam)
                console.log(each[0].id)
                console.log(each[0].name)
                const selectedUserName = each[0].name
                const selectedUserId = each[0].id; 
                //const selectedUserName = each[0].name; 
                if (isCurrent.current) { setUserId(selectedUserId) }
                if (isCurrent.current) { setSelectedUserName(selectedUserName) }
            }
        })
    }
    //-------------logging user----------------------/
    const a = "stojan";
    const b = "123456";
    const onHandler = async () => {
        const res = await loginUser(a, b)
        if(res) {
            getDataFirebase(queryParam)
        }
        console.log(res ? 'Getting data' : 'Network fail');
    }
    //--------------------------------/
    useEffect(() => {
        setShowSpinner(true);
        console.log("first - getting queryParams out of URL")
        gettingQueryParams();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    // RUNING USEEFFECT ONLY ONCE !!!!! on update !!!
    // -------- end 1 ---- fist is queryParam !! ---- //
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            // Your useEffect code here to be run on update
            console.log("second - getting logged in")
            onHandler();
            console.log("selected: " + selectedUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParam]);
    //---- end 2 ---- /
    const isInitialMountMed = useRef(true);

    useEffect(() => {
        if (isInitialMountMed.current) {
            isInitialMountMed.current = false;
        } else {
            console.log("third - getting medicine data")
            console.log("third - WE CAN SKIP THIS STEP NOT WORKING - dont know how to run useeffect only once AFTER child component mounted !!")
            // Your useEffect code here to be run on update
            //getDataFirebaseMedicine(userId) 
        }
    }, [userId]);
    //---- end 3 ---- //

    
    const isInitialMountCheckUser = useRef(true);

    useEffect(() => {
        if (isInitialMountCheckUser.current) {
            isInitialMountCheckUser.current = false;
        } else {
            console.log("fourth - getting logged out!")
            // Your useEffect code here to be run on update
            logoutUser();
            console.log("Odjavili ste se!")
            //if (isCurrent.current) { setCheckUserLogged(true) }
            setShowSpinner(false);
        }
    }, [userId]);
    //}, [<Recepti />]);
    //-------- end 4 -------- //

    const getLastWeightHandler = (getLastWeight) => {
        setLastWeight(getLastWeight);
    }

    //--------------------------------------------------//<p>{queryStringTitle()}</p>

    return (
        <div className={styles.Main}>
            
            {showSpinner ? 
                <Spinner /> :
                <div>
                    <RestInfo data={userId} passLW={lastWeight} name={selectedUserName} />
                    <Recepti data={userId} />
                    <div className={styles.Graphs}>
                        <WeightGraph data={userId} getLW={getLastWeightHandler} />
                        <GlucozeGraph data={userId} />
                        <PreasureGraph data={userId} />
                    </div>
                </div>
            }
        </div>
    )

}

export default Share;